import { getAddress } from '../../utils/address/getAddress.js';
export async function requestAddresses(client) {
    const addresses = await client.request({ method: 'eth_requestAccounts' });
    return addresses.map((address) => getAddress(address));
}
//# sourceMappingURL=requestAddresses.js.map